import axios from '../plugins/axios.js';
import InvalidPayload from '../exceptions/InvalidPayload.js';

export default {
    async getTaskEvents(payload = {}) {
        if (!payload.accountId) {
            throw new InvalidPayload('Account ID not provided.');
        }

        const response = await axios.get('v1/task-events', {
            params: payload,
        });

        return response.data.data;
    },

    async getWidgetData(payload = {}) {
        if (!payload.accountId) {
            throw new InvalidPayload('Account ID not provided.');
        }

        const response = await axios.get('v1/home', {
            params: payload,
        });

        return response.data;
    },

    async getCommunications(payload = {}) {
        if (!payload.accountId) {
            throw new InvalidPayload('Account ID not provided.');
        }

        const response = await axios.get('v1/communications', {
            params: payload,
        });

        return response.data;
    },

    async getVisits(payload = {}) {
        if (!payload.accountId) {
            throw new InvalidPayload('Account ID not provided.');
        }

        const response = await axios.get('v1/home/visits', {
            params: payload,
        });

        return response.data;
    },

    async stopVisit(leadId) {
        if (!leadId) {
            throw new InvalidPayload('Lead ID not provided.');
        }

        await axios.put(`v1/leads/${leadId}/visit`);
    },
};
